import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService, EventsService, PaymentV2Service, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
})
export class OfferComponent implements OnInit, OnDestroy {

  @Input() config;

  DEFAULT_CONFIG = {
    theme: ''
  };

  step = 1;

  title = 'Claim ₹300 More';
  subTextBold = 'Join Monthly Giving';
  subTextNormal = 'and ₹300 will be added to your SIP subscription.';
  btnText = 'Activate Offer';
  starImage = 'star-background-1';
  public btnClickCount = 0;
  public offerAmount = 300;
  offerRemoved = false;
  campaignId;
  userData;
  couponApplied = false;
  globalVar;
  params;


  subs: Subscription[] = [];

  @ViewChild('offerTemplate', { static: true }) public offerTemplate: TemplateRef<HTMLElement>;

  constructor(
    private dialog: MatDialog,
    private sheet: MatBottomSheet,
    public util: UtilService,
    private vars: VariablesService,
    private events: EventsService,
    private apiService: ApiService,
    private actRoute: ActivatedRoute,
    private paymentV2: PaymentV2Service
  ) { }

  ngOnInit() {
    this.params = this.actRoute.snapshot.queryParams;
    this.config = { ...this.DEFAULT_CONFIG, ...this.config };
    if (this.actRoute.snapshot.queryParams.coupon === 'sip_300' && !this.actRoute.snapshot.queryParams.offer) {
      setTimeout(() => this.openOfferPopup(), 2000);
    }

    this.subs.push(this.vars.userData.subscribe(res => {
      this.userData = res;
      if (!this.couponApplied && this.actRoute.snapshot.queryParams.st === 'f' && this.actRoute.snapshot.queryParams.offer) {
        this.applyCoupon();
      }
    }));

    this.subs.push(this.paymentV2.paymentConfig.subscribe((config) => {
      this.campaignId = this.util.checkNestedObj(config, 'paymentDetails.campaign.id') || this.campaignId;
      if (!this.couponApplied && this.actRoute.snapshot.queryParams.st === 'f' && this.actRoute.snapshot.queryParams.offer) {
        this.applyCoupon();
      }
      if (this.actRoute.snapshot.queryParams.offer && config && config.currency && config.currency !== 'INR' && !this.offerRemoved) {
        this.util.openSnackBar('Offer removed - Applied offer only applicable for Rupee', 'error');
        this.vars.offerActivated.next(0);
        this.offerRemoved = true;
      } else if (this.actRoute.snapshot.queryParams.offer && config && config.currency && config.currency === 'INR') {
        this.vars.offerActivated.next(this.actRoute.snapshot.queryParams.offer);
        this.offerRemoved = false;
      }
    }));

    this.subs.push(this.vars.globalVar.subscribe({
      next: (resp) => {
        this.globalVar = resp;
      }
    }));

  }

  openOfferPopup() {
    this.events.sendSystemEvent({
      eventName: 'incentive_popup',
      page_name: this.vars.pageName,
      info_3: 'impact',
    }).subscribe(_ => _);
    if (this.util.isMobile()) {
      this.sheet.open(this.offerTemplate, {
        disableClose: true,
      });
    } else {
      this.dialog.open(this.offerTemplate, {
        width: '100%',
        maxWidth: '340px',
        disableClose: true,
      });
    }
  }

  /**
   * Triggers on click of button
   */
  changeValues() {
    this.btnClickCount++;
    if (this.btnClickCount >= 2) {
      this.sendEvent('42');
      this.applyCoupon();
      this.closeDialog();
    } else {
      this.title = 'Yay! Redeem Offer';
      this.subTextBold = 'Your offer is ready.';
      this.subTextNormal = 'Sign up now to avail additional ₹300 on your donation.';
      this.btnText = 'Signup & Redeem';
      this.starImage = 'star-background-2';
      this.sendEvent('41');
    }
  }

  /**
   * Applies coupon/offer in db
   */
  applyCoupon(): void {
    if (!this.campaignId || !this.userData) {
      return;
    }
    this.apiService.applyCoupon(this.campaignId, { coupon_id: 24 }).subscribe(() => { });
    if (this.config?.theme?.match('1')) {
      this.step = 2;
      setTimeout(() => {
        this.closeDialog();
      }, 2500);
    }
    this.couponApplied = true;
    this.vars.offerActivated.next(300);
    this.util.router.navigate([], { queryParams: { offer: 300 }, queryParamsHandling: 'merge' });
  }

  /**
   * Sends system events
   * @param position position to be sent in info_2
   */
  sendEvent(position: string): void {
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      info_1: 'position',
      info_2: position,
      info_3: 'impact',
    }).subscribe(_ => _);
  }
  /**
   * Closes dialog/bottom sheet
   */
  closeDialog(): void {
    this.util.isMobile() ? this.sheet.dismiss() : this.dialog.closeAll();
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
